import { isMobile } from 'utilities/browser';

const IdentificationMethodContent = {
    ibanContent: {
        title: 'identification-ibanTitle',
        singleTitle: 'identification-ibanTitleSingleMethod',
        abbrTitle: 'identification-ibanAbbrTitle',
        content: 'identification-ibanContent',
        singleContent: 'identification-ibanContentSingleMethod',
        modalTittle: 'identity-ibanModalOtherIban',
        modalContent: 'identity-ibanModalOtherIbanDescription',
        modalButtonText: 'button-chooseOtherIban',
    },

    videoSelfieContent: {
        title: 'identification-videoSelfieTitle',
        singleTitle: 'identification-videoSelfieTitleSingleMethod',
        abbrTitle: 'identification-videoSelfieAbbrTitle',
        content: 'identification-videoSelfieContent',
        singleContent: 'identification-videoSelfieContentSingleMethod',
        modalTittle: 'identity-ibanModalSelfie',
        modalContent: 'identity-ibanModalSelfieDescription',
        modalButtonText: 'button-chooseSelfie',
    },

    videoSelfieWithoutBiometricsContent: {
        title: 'identification-videoSelfieWithoutBiometricsTitle',
        singleTitle: 'identification-videoSelfieWithoutBiometricsTitleSingleMethod',
        abbrTitle: 'identification-videoSelfieWithoutBiometricsAbbrTitle',
        content: 'identification-videoSelfieWithoutBiometricsContent',
        singleContent: 'identification-videoSelfieWithoutBiometricsContentSingleMethod',
        modalTittle: 'identity-ibanModalSelfie',
        modalContent: 'identity-ibanModalSelfieDescription',
        modalButtonText: 'button-chooseSelfie',
    },

    videosContent: {
        title: 'identification-videoTitle',
        singleTitle: 'identification-videoTitleSingleMethod',
        abbrTitle: 'identification-videoAbbrTitle',
        content: 'identification-videoContent',
        singleContent: 'identification-videoContentSingleMethod',
        modalTittle: 'identity-ibanModalOtherVideo',
        modalContent: 'identity-ibanModalOtherVideoDescription',
        modalButtonText: 'button-chooseVideos',
    },

    videoCallContent: {
        title: 'identification-videoCallTitle',
        singleTitle: 'identification-videoCallTitleSingleMethod',
        abbrTitle: 'identification-videoCallAbbrTitle',
        content: 'identification-videoCallContent',
        singleContent: 'identification-videoCallContentSingleMethod',
        modalTittle: 'identity-ibanModalVideocall',
        modalContent: 'identity-ibanModalVideocallDescription',
        modalButtonText: 'button-chooseVideocall',
        timeAlertText: 'identity-ibanModalVideocallOff',
    },
    transferContent: {
        title: 'identification-transferTitle',
        singleTitle: 'identification-transferTitleSingleMethod',
        abbrTitle: isMobile() ? 'identification-transferAbbrTitleMobile' : 'identification-transferAbbrTitle',
        content: 'identification-transferContentInfo',
        singleContent: 'identification-transferContentInfoSingleMethod',
        modalTittle: 'identity-ibanModalTransfer',
        modalContent: 'identity-ibanModalTransferDescription',
        modalButtonText: 'button-chooseTransfer',
    },
    courierContent: {
        title: 'identification-addressTitle',
        singleTitle: 'identification-addressTitleSingleMethod',
        abbrTitle: 'identification-addressAbbrTitle',
        content: 'identification-addressContent',
        singleContent: 'identification-addressContentSingleMethod',
    },
};
export default IdentificationMethodContent;
